<div class="lg:px-6 xl:px-7 2xl:px-8 narrow-inner-container">
	<slot />
</div>
